export default __webpack_public_path__ + "static/media/Editor_choice_MDPI_Water.64765a53.jpg";